
export const roles = {
    rmOperator : 'Operator',
    rmSupervisor :'Supervisor',
    rmAdministrator : 'Administrator',
    hbAdministrator : 'SPTS Administrator',
    viewer : 'SPTS Viewer',
    pricingAdmin : 'SPTS Pricing Admin',
    salesRep :'SPTS Sales Rep',
    suppliesBusinessOwner : 'Supplies Business Owner',
}

export const rolePageMapping= {
    supplyencoding : [],    // obsolete
    supplyinspection : [],  // obsolete
    account: [roles.rmSupervisor, roles.rmAdministrator],
    download: [],           // obsolete
    admin:[roles.rmAdministrator],
    accountManagement:[roles.salesRep, roles.hbAdministrator],
    monthlyPrice:[roles.viewer,roles.pricingAdmin,roles.salesRep,roles,roles.hbAdministrator,roles.viewer],
    administration: [roles.hbAdministrator],
    supplycatalog : [roles.suppliesBusinessOwner],
    fwcatalog: [],
    swcatalogupload: [roles.suppliesBusinessOwner,roles.hbAdministrator],
    swdownload: [roles.rmOperator,roles.rmSupervisor, roles.rmAdministrator]
}

export const UIMapping = (role) =>{
    let permissions = {
        // tabs UI configuration
        supplyEncoding: false,
        supplyInspection: false,
        accountDetailMonthlySummary: false,
        fwDownload: false,
        swDownload: false,
        userAdministrationReman: false,
        accountManagement: false,
        monthlySummarySPS: false,
        userAdministrationSps: false,
        supplyCatalog:false,
        fwCatalog:false,
        swCatalog:false,
        // navigation UI configuration
        navbarISO:false,
        navbarSPS:false,
        navbarHB:false,
        navigation:true,
        //monthlyPrice Component UI Control
        checkBoxEditPermission:false,
        priceEditPermission:false,
        capEditPermission:false,
        showAdjustmentSection:false,
        enabledOnlyForFutureQuarter:false
    };
    switch (role) {
        case roles.rmOperator:
            return {
                ...permissions,
                swDownload: true,
                navbarISO:true,
                navigation:false
            };
        case roles.rmSupervisor:
            return {
                ...permissions,
                accountDetailMonthlySummary:true,
                swDownload: true,
                navbarISO : true,
                navigation:false
            };
        case roles.rmAdministrator:
            return {
                ...permissions,
                accountDetailMonthlySummary:true,
                swDownload: true,
                userAdministrationReman:true,
                navbarISO: true,
                navigation:false
            };
        case roles.hbAdministrator:
            return {
                ...permissions,
                accountManagement:true,
                monthlySummarySPS:true,
                userAdministrationSps:true,
                swCatalog:true,
                checkBoxEditPermission:true,
                priceEditPermission:true,
                capEditPermission:true,
                showAdjustmentSection:true,
                navbarHB:true,
                navigation:false
            };
        case roles.viewer:
            return {
                ...permissions,
                monthlySummarySPS:true,
                navbarSPS:true,
                navigation:false
            };
        case roles.pricingAdmin:
            return {
                ...permissions,
                monthlySummarySPS:true,
                checkBoxEditPermission:true,
                priceEditPermission:true,
                enabledOnlyForFutureQuarter:true,
                showAdjustmentSection:true,
                navbarSPS:true,
                navigation:false
            };
        case roles.salesRep:
            return {
                ...permissions,
                accountManagement:true,
                monthlySummarySPS:true,
                capEditPermission:true,
                showAdjustmentSection:true,
                navbarSPS:true
            };
        case roles.suppliesBusinessOwner:
            return {
                ...permissions,
                supplyCatalog: true,
                swCatalog:true
            };
        default:
            return permissions;
    }
}
